<finder-layout
    [error]="dataError"
    [languageBundle]="languageBundle?.systemError"
    [loaded]="loadingSg()"
>
    <div class="header">
        @defer {
            @if (useSyndicated) {
                <finder-syndicated-header
                    [url]="syndicatedLayoutConfigs['baseUrl'] + syndicatedLayoutConfigs['header'].path"
                    [version]=" syndicatedLayoutConfigs['header'].siteConfigs[siteId]?.version"
                    [siteId]="siteId"
                    [environment]="environment"
                >
                </finder-syndicated-header>
            }
        }
    </div>
    <div class="content" role="main">
        <ng-container #rootComponents></ng-container>
        <router-outlet></router-outlet>
    </div>
    <div class="footer">
        @if (useSyndicated) {
            <finder-syndicated-footer
                [url]="syndicatedLayoutConfigs['baseUrl'] +  syndicatedLayoutConfigs['footer'].path"
                [version]="syndicatedLayoutConfigs['footer'].siteConfigs[siteId]?.version"
                [siteId]="siteId"
                [environment]="environment"
            >
            </finder-syndicated-footer>
        }
    </div>
    <ng-template #customHeaderTemplate class="header"></ng-template>
    <ng-template #customFooterTemplate class="footer"></ng-template>
</finder-layout>
